<label [ngClass]="{'check': !mode, 'switch': isSwitch}">
  <input [ngClass]="{'check__input': !mode, 'switch__input': isSwitch}"
         [attr.name]="name"
         [attr.value]="value"
         [attr.type]="type"
         [disabled]="disabled"
         [checked]="isChecked"
         (change)="changeValue($event)">
  <span [ngClass]="{'check__box': !mode, 'switch__box': isSwitch}">
    <span *ngIf="isCheckbox && !isSwitch"
          class="check__icon"
          aria-label="check">
      <icon-check></icon-check>
    </span>
  </span>
  <span [ngClass]="{'check__text': !mode, 'switch__text': isSwitch}">
    <ng-content></ng-content>
  </span>
</label>
